import {NgModule} from "@angular/core";
import {TrimFormFieldsDirective} from "./trim-form-value.directive";

@NgModule({
  declarations: [TrimFormFieldsDirective],
  exports: [TrimFormFieldsDirective]
})
export class TrimFormValueModule {}
